import { useMemo } from "react"
import { findCountry } from "../helpers"

const COUNTRIES_WITHOUT_NEWSLETTER = ["br", "au", "hk", "cn", "in", "my"]

const useNewsletterUrl = (location: Location) => {
  const url = useMemo(() => {
    const country = findCountry(location.hostname, location.pathname)

    if (!country || COUNTRIES_WITHOUT_NEWSLETTER.some((c) => c === country)) {
      return null
    }

    return `https://www.belimo.com/${country}/e-newsletter`
  }, [location])

  return url
}

export default useNewsletterUrl
